export default __webpack_public_path__ + "static/media/ya.2f2874d9.png";